$(document).ready(function(){

  
  $('img[src="//www.vaerwatches.com/cdn/shop/files/4Brand-Logos-181818.jpg?v=1680563064&width=400"]').attr('alt', 'GQ Logo');

$('img[src="//www.vaerwatches.com/cdn/shop/files/1Brand-Logos-181818.jpg?v=1680562945&width=400"]').attr('alt', 'Hodinkee Logo');

$('img[src="//www.vaerwatches.com/cdn/shop/files/3Brand-Logos-181818.jpg?v=1680563042&amp;width=400"]').attr('alt', 'Teddy Logo');

$('img[src="//www.vaerwatches.com/cdn/shop/files/6Brand-Logos-181818.jpg?v=1680563234&width=400"]').attr('alt', 'Gear Patrol Logo');

$('img[src^="//www.vaerwatches.com/cdn/shop/files/2Brand-Logos-181818.jpg?v=1680562992&amp;width=400"]').attr('alt', 'A Blog to Watch Logo');

$('img[src="//www.vaerwatches.com/cdn/shop/files/5Brand-Logos-181818.jpg?v=1680563099&width=400"]').attr('alt', 'Worn and Wound Logo');
$('img[src^="//www.vaerwatches.com/cdn/shop/files/3Brand-Logos-181818.jpg?"]').attr('alt', 'Teddy Logo');
$("h2#SmartCart_title").append("<span style='display:none'>.</span>");
$('img[src^="//www.vaerwatches.com/cdn/shop/files/2Brand-Logos-181818.jpg?v=1680562992?"]').attr('alt', 'A Blog to Watch Logo');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-1-Waterproof_2feda98a-a8a6-472a-a5c4-e60b9ecaaffa.jpg?v=1683224583&width=400"]').attr('alt', 'Guaranteed Waterproof');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-3-Sapphire_ffd96d2a-8dec-4cbe-9a7a-2dfe609a7117.jpg?v=1683224598&width=400"]').attr('alt', 'Sapphire Crystal');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-Straps.jpg?v=1683134872&width=400"]').attr('alt', '2x Straps Standard Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-Comfort.jpg?v=1683134663&width=400"]').attr('alt', 'Comfort Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-Comfort.jpg?v=1683134663&width=400"]').attr('alt', 'American Flag');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-2-USA_41f0c0c5-1028-4269-8ea5-e3bb7c45b57a.jpg?v=1683224639&width=400"]').attr('alt', 'USA Made Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-Movements.jpg?v=1683134896&width=400"]').attr('alt', 'Movements Icon');
$('.notify-pn-bk-stock-input-email').attr('aria-label', 'Enter your email');
$('img[src="//www.vaerwatches.com/cdn/shop/files/preview_images/d3266e2b1a5245a2943bf10860ca2e61.thumbnail.0000000000_400x.jpg?v=1731111770"]').attr('alt', 'video thumbnail');

$('img[src="//www.vaerwatches.com/cdn/shop/files/preview_images/2ef33f3ec5fc4abebc3dd81c9725d64e.thumbnail.0000000000_800x.jpg?v=1731111124"]').attr('alt', 'video thumbnail');
$("button#sca-fg-today-offer-widget").append("<span style='display:none'>.</span>");
  $("h2.rebuy-cart__flyout-title").append("<span style='display:none'>.</span>");
  $('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-Warranty.jpg?v=1683134935&width=400"]').attr('alt', '2 year warranty');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-Surgical.jpg?v=1683134961&width=400"]').attr('alt', 'surgical grade steel');
$("#scroll-area-template--16470199894150__0b68cd38-319b-490b-84e2-1a825b015dd2 > div:nth-child(5) > a > img.zoom-image").attr("alt","a blog to watch");
  $("h3.p1>span.s3>b:empty").append("<span style='display:none'>.</span>");

  $("h3.p1>img[src='https://cdn.shopify.com/s/files/1/1165/0300/files/36-CompareUpdate-Guide.jpg?v=1712687387']").append("<span style='display:none'>.</span>");
  $('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/38-wrist38.jpg?v=1712350381"]').attr('alt', 'Person wearing Vaer watch on 7 cm wrist');
$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/36-CompareUpdate-Guide.jpg?v=1712687387"]').attr('alt', '36 mm and 40 mm size comparison');

$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/39-case39.jpg?v=1712350758"]').attr('alt', '39 mm dive case');

$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/38-Compare_CopyUpdate-Guide.jpg?v=1712687421"]').attr('alt', '38 mm watch dial comparison with 42 mm watch dial');

$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/39-wrist39.jpg?v=1712350777"]').attr('alt', 'Person showing 39mm dial Vaer watch');
$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/40-case40.jpg?v=1712351256"]').attr('alt', '40 mm watch dial');
$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/40-wrist40.jpg?v=1712351275"]').attr('alt', 'Person showing his 40 mm dial watch');
$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/36-case_1776364f-b9fc-4821-a4ba-670e89c208a3.jpg?v=1712350095"]').attr('alt', '36 mm field case');
$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/36-wrist_6cce1384-1097-43dd-8f6d-70b20f854915.jpg?v=1712349837"]').attr('alt', 'Person showing his 36 mm dial watch');
$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/42-case42.jpg?v=1712351506"]').attr('alt', '42 mm dive case');

$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/42-wrist42.jpg?v=1712351525"]').attr('alt', 'Person showing his 42 mm dial watch');

$('img[src="https://cdn.shopify.com/s/files/1/1165/0300/files/Straps-Detail-5_2048x2048.jpg?v=1728506769"]').attr('alt', 'Strap details');
$('img[src="//www.vaerwatches.com/cdn/shop/files/C5-DD-Highlight-1_9e310694-575a-453c-9837-a13aeb842900.jpg?v=1722281895&width=1500"]').attr('alt', 'Person doing watch crafting work');

$('img[src="//www.vaerwatches.com/cdn/shop/files/C5-DD-Highlight-2_cb57d40a-f8d3-429e-8950-dfff019e4cc6.jpg?v=1722281924&width=1500"]').attr('alt', 'Person doing watch crafting work');
$('img[src="//www.vaerwatches.com/cdn/shop/files/C5-DD-Highlight-1.jpg?v=1715722297&width=1500"]').attr('alt', 'Men doing watch crafting work');
$('img[src="//www.vaerwatches.com/cdn/shop/files/C5-DD-Highlight-2.jpg?v=1715722315&width=1500"]').attr('alt', 'Men designing watch');
$('img[src*="thumbnail.0000000000_small.jpg"]').attr('alt', 'Video thumbnail');
$('img[src*="thumbnail.0000000000_400x"]').attr('alt', 'Video thumbnail');
$('img[src*="thumbnail.0000000000_800x.jpg"]').attr('alt', 'Video thumbnail');
  
  
  
$("input.forms-check-inputCstm-ld").attr("aria-label","Add order note checkbox");
  $('img[src="//www.vaerwatches.com/cdn/shop/files/S3-Highlight-2_copy.jpg?v=1728337284&width=1000"]').attr('alt', 'S3 calendar field black watch');

$('img[src="//www.vaerwatches.com/cdn/shop/files/S5-Highlight-2_copy_07861cc4-de9a-4381-bf24-1cd9fb68dc7a.jpg?v=1728336679&width=1000"]').attr('alt', 'Man wearing S3 calendar field black watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/1DD-Highlight.jpg?v=1728079152&width=1000"]').attr('alt', 'Army soldiers holding guns');

$('img[src="//www.vaerwatches.com/cdn/shop/files/2DD-Highlight.jpg?v=1728079173&width=1000"]').attr('alt', 'A12 Dirty Dozen watch face');
$('img[src="//www.vaerwatches.com/cdn/shop/files/S3-Highlight-1_copy.jpg?v=1728349949&width=1000"]').attr('alt', 'S5 Calendar Field Black');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Korea-Highlight-1.jpg?v=1728322893&width=1000"]').attr('alt', 'C5 Korean Field Watch');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Korea-Highlight-2.jpg?v=1728322907&width=1000"]').attr('alt', 'Soldiers holding gun and sitting on stones');
$('img[src="//www.vaerwatches.com/cdn/shop/files/A3-KF-14.jpg?v=1741708075&width=1400"]').attr('alt', 'Person wearing A3 Korean Field Watch');

$('img[src="//www.vaerwatches.com/cdn/shop/files/A3-OK-5_dd90920e-7dcc-492c-9d26-ace55c693234.jpg?v=1738098052&width=1200"]').attr('alt', 'A3 Korean Field Watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/A3-OK-7_4fd86b22-e848-4f21-9585-d6dfab1cb5d4.jpg?v=1738098052&width=1200"]').attr('alt', 'A3 Tradition Unknown Watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/A3-KF-6.jpg?v=1741721491&width=1200"]').attr('alt', 'A3 Korean Field Watch');
$('section.shopify-section.shopify-section--media-grid a.media-grid__item.shadow.group  div[id^="media-grid-image"] img').each(function() {
    if (!$(this).attr('alt') || $(this).attr('alt').trim() === '') {
        $(this).attr('alt', 'Product Image');
    }
});
$('img[src="//www.vaerwatches.com/cdn/shop/files/36-wristWrist-Shot-Lime.jpg?v=1712715059&width=600"]').attr('alt', 'Person wearing 36mm watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/38-wristWrist-Shot-Lime.jpg?v=1712715073&width=600"]').attr('alt', 'Person wearing 38mm watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/39-wristWrist-Shot-Lime.jpg?v=1712715088&width=600"]').attr('alt', 'Person wearing 39mm watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/40-wristWrist-Shot-Lime.jpg?v=1712715102&width=600"]').attr('alt', 'Person wearing 40mm watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/42-wristWrist-Shot-Lime.jpg?v=1712715120&width=600"]').attr('alt', 'Person wearing 42mm watch');
$('img[src="//www.vaerwatches.com/cdn/shop/files/ArtboardEco-Icons-Smaller.jpg?v=1731170559&width=900"]').attr('alt', '1% for the planet');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Artboard_Copy_9Eco-Icons-Smaller.jpg?v=1731170595&width=900"]').attr('alt', 'We will repair not replace');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Artboard_CopyEco-Icons-Smaller.jpg?v=1731170624&width=900"]').attr('alt', 'Sun icon');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Artboard_Copy_8Eco-Icons-Smaller.jpg?v=1731170641&width=900"]').attr('alt', 'Product recycling');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Artboard_Copy_6Eco-Icons-Smaller.jpg?v=1731170658&amp;width=900"]').attr('alt', 'American flag');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Artboard_Copy_10Eco-Icons-Smaller.jpg?v=1731170677&width=900"]').attr('alt', 'Plant');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Eco-Squares-Artboard.jpg?v=1731173831&width=1000"]').attr('alt', 'Men came out of scuba diving');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Eco-Squares-Artboard_Copy_12.jpg?v=1731173874&width=1000"]').attr('alt', 'Girl with her dog');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Eco-Squares-Artboard_Copy_11.jpg?v=1731173944&width=1000"]').attr('alt', 'Woman standing on a beach');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Eco-Squares-Artboard_Copy_14.jpg?v=1731173912&width=1000"]').attr('alt', 'Man sitting on a beach');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Eco-Squares-Artboard_Copy_13.jpg?v=1731173928&width=1000"]').attr('alt', 'Woman standing on a beach');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Artboard_Copy_6Eco-Icons-Smaller.jpg?v=1731170658&width=900"]').attr('alt', 'American flag');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Eco-Squares-Artboard_Copy_15.jpg?v=1731173892&width=1000"]').attr('alt', 'A man on his motorcycle');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Vaer_Logo_White_Small_1a6c2582-5bbb-4f7e-9c99-c39862b220b4.png?v=1678124665&width=500"]').attr('alt', 'Vaer logo');
$('input[name="name"]').attr('aria-label', 'Enter your name');
$('input[name="email"]').attr('aria-label', 'Enter your email address');
$('textarea[name="question"]').attr('aria-label', 'Enter your question');
$('input[name="noop"]').attr('aria-label', 'No operation field');

$('a.cpCloseLink').attr('aria-label', 'Close popup');
$('input[name="b_9d1188bccf99f8799497f21dc_47fc4c9564"]').attr('aria-label', 'Enter your email address');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Free-Shipping-Icon.png?v=1680557445&width=80"]').attr('alt', 'Free Shipping Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Waterproof-Icon.png?v=1680558098&width=80"]').attr('alt', 'Waterproof Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Two-Straps-Icon-Navy.png?v=1680559204&width=80"]').attr('alt', 'Two Straps Icon Navy');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Outside-Olive.png?v=1726255926&width=450"]').attr('alt', "Outside Buyer's Guide");
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {
      $('div.klaviyo-form-XdS6U4 input').removeAttr('aria-labelledby');
   $("div.klaviyo-form-XdS6U4 div[role='listbox']").removeAttr('aria-labelledby');


      
 $("input.notify-pn-bk-stock-input-email").attr("aria-label","Enter your email"); 
      $('input[id^="Warranty_Start_Date_"]').attr('aria-label', 'Warranty Start Date');
$("button#sca-fg-today-offer-widget").append("<span style='display:none'>.</span>")
$("label.adb-switch").append('<span style="display:none">.</span>');
 $("h2.rebuy-cart__flyout-title").append("<span style='display:none'>.</span>");
$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
$('img[src="//www.vaerwatches.com/cdn/shop/files/VAER_logo_black.png?v=1678125124&width=679"]').attr('alt', 'VAER logo ');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Vaer_Logo_White_Small_1a6c2582-5bbb-4f7e-9c99-c39862b220b4.png?v=1678124665&width=500"]').attr('alt', 'VAER logo ');
$('input[name="q"]').attr('aria-label', 'Enter search term');

$('.search-input button[type="submit"]').attr('aria-label', 'Submit search');
$('a[href="https://journal.vaerwatches.com/review-of-vaer-horween-leather-bands/"]').attr('aria-label', 'Review of Vaer Horween Leather Bands');
$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-1-Waterproof.jpg?v=1681243368&width=400"]').attr('alt', 'Waterproof Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Screw-Crown-Icon.jpg?v=1715649702&width=600"]').attr('alt', 'Screw Crown Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/Feature-Icons-Comfort.webp?v=1696620135&width=400"]').attr('alt', 'Clock Icon');

$('img[src="//www.vaerwatches.com/cdn/shop/files/bMilitary-Page-Images.jpg?v=1731107566&width=1000"]').attr('alt', 'Soldier giving message on wireless');

$('img[src="//www.vaerwatches.com/cdn/shop/files/c_copy_5Military-Page-Images.jpg?v=1731107607&width=1000"]').attr('alt', 'Military edition watch with green strap');

$('img[src="//www.vaerwatches.com/cdn/shop/files/c_copyMilitary-Page-Images.jpg?v=1731107634&width=1000"]').attr('alt', 'Person doing scuba diving');

$('img[src="//www.vaerwatches.com/cdn/shop/files/c_copy_4Military-Page-Images.jpg?v=1731107670&width=1000"]').attr('alt', 'Vaer watch with black chain');

$('img[src="//www.vaerwatches.com/cdn/shop/files/c_copy_2Military-Page-Images.jpg?v=1731107698&width=1000"]').attr('alt', 'Military men smiling and posing for a picture');

$('img[src="//www.vaerwatches.com/cdn/shop/files/c_copy_3Military-Page-Images.jpg?v=1731107730&width=1000"]').attr('alt', 'Army men holding gun');

$('div.announcement-bar__scrolling-list').hover(
  function() { $(this).css('animation-play-state', 'paused'); },
  function() { $(this).css('animation-play-state', 'running'); }
);

  $("aside#shopify-section-sections--16470195601542__announcement-bar").attr("aria-hidden","true");
  $('span.announcement-bar__item p').attr("aria-hidden","true");
  $('span.announcement-bar__item span').attr("aria-hidden","true");
    $('span.announcement-bar__item a').attr("aria-hidden","true");
      $('span.announcement-bar__item a').attr("tabindex","-1");
  $('img[src="//www.vaerwatches.com/cdn/shop/files/2Brand-Logos-181818.jpg?v=1680562992&width=400"]').attr('alt', "A Blog to Watch logo");

  /*
$('span.announcement-bar__item').attr("aria-hidden","true");
$('span.announcement-bar__item a[href="https://www.vaerwatches.com/pages/vaer-customer-reviews"]').attr("aria-hidden","true");
  $("h1.header__logo>a>span.sr-only").attr("aria-hidden","true");
  $("h1.header__logo").attr("aria-hidden","true");
$("div.announcement-bar").attr("aria-hidden","true");

  $("#shopify-section-sections--16470195601542__announcement-bar > height-observer > div > div > span:nth-child(1) > p:nth-child(5) > a").attr("aria-hidden","true");
*/
  
});
